module.exports = __webpack_public_path__ + "static/media/drape.1e9ed8f0.m4a";